// extracted by css-extract-rspack-plugin
export default {"default_button_override":"W4Dc5","defaultButtonOverride":"W4Dc5","#":"np7Wv","label_override":"I2JRM","labelOverride":"I2JRM"};